// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__6osAT","error":"checkbox_error__mUX40"};